import { twMerge } from 'tailwind-merge';

/**
 * Returns concatenated tailwind class names
 * @param classes - Tailwind class names
 */
export default function tailwindClassNames(...classes: string[]): string {
  return twMerge(classes.filter(Boolean).join(' '));
}
